import { UserContext } from 'core/userContext';
import { useEffect } from 'react';

export const loginUser = (zendeskJwt: string) => {
  /**
   * Zendesk chat script lives in chatSupport.scala.html in the iterable repo
   * As long as it is initialized, window.zE will be defined.
   */
  if (window.zE) {
    /** Log current user in to Zendesk, using the JWT provided by BE */
    window.zE('messenger', 'loginUser', (callback: (zendeskJwt: string) => void) => {
      callback(zendeskJwt);
    });
  }
};

export const useAuthenticateZendeskChat = (
  SupportChatAgentWorkspace: boolean,
  SupportChatAgentWorkspaceAuth: boolean,
  userContext: UserContext,
) => {
  const { zendeskJwt, showLiveChat } = userContext;

  useEffect(() => {
    /**
     * SupportChatAgentWorkspace enables the newest version of Zendesk chat
     * SupportChatAgentWorkspaceAuth enables authentication of the user via JWT
     * showLiveChat enables Zendesk chat (as opposed to the default Ada chat)
     * zendeskJwt is provided by the BE in order to authenticate the user to Zendesk
     */
    if (SupportChatAgentWorkspace && SupportChatAgentWorkspaceAuth && showLiveChat && zendeskJwt) {
      loginUser(zendeskJwt);
    }
  }, [SupportChatAgentWorkspace, SupportChatAgentWorkspaceAuth, showLiveChat, zendeskJwt]);
};
